import Store from '@/Services/Store';

export default {
  translate(key) {
    if (Object.keys(Store.state.translations).length === 0) return '?';

    return Store.state.translations[key] || key;
  },
};
